module.exports = __webpack_public_path__ + "img/Inside-sp_10.e58095f2.jpg";